import {Injectable} from "@angular/core";
import {CoreApiService} from "../../../core/service/core-api.service";
import {Observable} from "rxjs";
import {ChannelOverviewDto} from "../types/user-channels.types";
import {UserInteractionTypeDto} from "../../../ci/types/ds-interaction.types";

@Injectable({ providedIn: 'root' })
export abstract class UserChannelsApiService {

  endPoint: string = "mvseu/eu/endUser/channels"

  constructor(
    protected coreApiService: CoreApiService) {
  }

  public saveChannels(dto: ChannelOverviewDto) : Observable<UserInteractionTypeDto> {
    return this.coreApiService.create(dto, `${this.endPoint}`);
  }

  public getChannels(): Observable<ChannelOverviewDto> {
    return this.coreApiService.get(`${this.endPoint}`);
  }


}
